<highcharts-chart
  [Highcharts]="Highcharts"
  [options]="chart"
  style="height: 350px; width: 100%; display: block"></highcharts-chart>
